import { FC, ReactNode, useState } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { ModalDialogProvider } from "../../contexts/ModalDialogContext";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar, { SIDEBAR_WIDTH } from "./DashboardSideBar";

const Wrapper = styled.div`
  padding-left: ${SIDEBAR_WIDTH}px;
  height: 100vh;
  overflow: hidden;
  @media (max-width: 960px) {
    padding-left: 0;
  }
`;

const ContentWrapper = styled.div`
  padding: 0 24px 24px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  @media (max-width: 600px) {
    padding: 0 16px 16px;
  }
`;

const DashboardLayout: FC<{ children?: ReactNode }> = ({ children }) => {
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  const toggleMobileSideBar = () => setShowMobileSideBar((prev) => !prev);

  return (
    <ModalDialogProvider>
      <DashboardSidebar
        showMobileSideBar={showMobileSideBar}
        closeMobileSideBar={() => setShowMobileSideBar(false)}
        toggleMobileSideBar={toggleMobileSideBar}
      />

      <Wrapper className="x100">
        <DashboardNavbar toggleMobileSideBar={toggleMobileSideBar} />
        <ContentWrapper>{children || <Outlet />}</ContentWrapper>
      </Wrapper>
    </ModalDialogProvider>
  );
};

export default DashboardLayout;
